import axios from './../axios'
import _ from 'lodash'

export default async function (action, args, displayId, payload) {
    console.log('cart-rule-action:replace_product', { action, args })

    const { item } = args

    const products = Object.values(window.addiesaas.products.types)
        .flat(1)

    const product = products.find(p => p.id == action.options.product_id)

    if (!item || !product) {
        return
    }

    const originalProduct = item.attributes.product
    const originalCount = item.payload.count || 1

    item.attributes.original_product = _.cloneDeep(originalProduct)

    item.attributes.product = _.cloneDeep(product)

    item.payload.product_id = product.id
    item.type = product.type
    item.name = product.name
    item.title = product.title
    item.total = product.price

    let options = action.options.options || null
    if (options) {
        options = window.addiesaas.$fn.formatters.templify(JSON.parse(options), args)
        _.merge(item.payload.options, options)
    }

    _.merge(item.payload.options, {
        cart_rule_display_id: displayId,
    })

    const count = item.payload.count || 1

    const store = window.addiesaas.store

    await store.dispatch('Shop/Orders/Cart/updateCartItem', item)

    window.addiesaas.$core.EventBus.$emit('cart.validate')

    payload.upsell_value = product.price * count - originalProduct.price * originalCount
}
